import axios from 'axios';

// A localhost URL baked in at build time is unreachable from a visitor's browser,
// so fall back to same-origin (nginx proxies /api to the backend).
const ENV_BASE = process.env.REACT_APP_API_URL || '';
const BASE = /localhost|127\.0\.0\.1/.test(ENV_BASE) ? '' : ENV_BASE;

const api = axios.create({ baseURL: BASE, timeout: 15000 });

// ── Core ──────────────────────────────────────────────────────────────
export const getStats       = ()             => api.get('/api/stats').then(r => r.data);
export const getThreats     = (params = {})  => api.get('/api/threats', { params }).then(r => r.data);
export const getThreat      = (id)           => api.get(`/api/threats/${id}`).then(r => r.data);
export const getAlerts      = (params = {})  => api.get('/api/alerts', { params }).then(r => r.data);
export const ackAlert       = (id)           => api.post(`/api/alerts/${id}/acknowledge`).then(r => r.data);
export const getMlMetrics   = ()             => api.get('/api/ml/metrics').then(r => r.data);
export const getGeoAttacks  = ()             => api.get('/api/geo/attacks').then(r => r.data);
export const getTopSources  = ()             => api.get('/api/top-sources').then(r => r.data);
export const getAttackTypes = ()             => api.get('/api/attack-types').then(r => r.data);
export const getTimeline    = ()             => api.get('/api/timeline').then(r => r.data);

// ── Threat Hunting ────────────────────────────────────────────────────
export const hunt            = (params = {}) => api.get('/api/hunt', { params }).then(r => r.data);
export const updateStatus    = (id, status, note) => api.patch(`/api/threats/${id}/status`, { status, note }).then(r => r.data);
export const addNote         = (id, content, author) => api.post(`/api/threats/${id}/notes`, { content, author }).then(r => r.data);
export const getSavedQueries = ()            => api.get('/api/saved-queries').then(r => r.data);
export const saveQuery       = (q)           => api.post('/api/saved-queries', q).then(r => r.data);
export const deleteQuery     = (id)          => api.delete(`/api/saved-queries/${id}`).then(r => r.data);

// ── IOC Management ────────────────────────────────────────────────────
export const getIOCs         = ()            => api.get('/api/iocs').then(r => r.data);
export const addIOC          = (ioc)         => api.post('/api/iocs', ioc).then(r => r.data);
export const deleteIOC       = (id)          => api.delete(`/api/iocs/${id}`).then(r => r.data);
export const searchIOC       = (value)       => api.post('/api/iocs/search', { value }).then(r => r.data);

// ── Threat Intelligence ───────────────────────────────────────────────
export const enrichIP        = (ip)          => api.get(`/api/threat-intel/ip/${ip}`).then(r => r.data);
export const getIPHistory    = (ip)          => api.get(`/api/ip/${ip}/history`).then(r => r.data);

// ── ML ────────────────────────────────────────────────────────────────
export const submitFeedback     = (data)     => api.post('/api/ml/feedback', data).then(r => r.data);
export const getFeatureImportance = ()       => api.get('/api/ml/feature-importance').then(r => r.data);

// ── Analytics ─────────────────────────────────────────────────────────
export const getHeatmap      = (days = 7)    => api.get(`/api/analytics/heatmap?days=${days}`).then(r => r.data);
export const getMITRECoverage = (hours = 24) => api.get(`/api/mitre/coverage?hours=${hours}`).then(r => r.data);

// ── Reports ───────────────────────────────────────────────────────────
export const generateReport     = (type, fmt, hours) =>
  api.get('/api/reports/generate', { params: { report_type: type, fmt, hours }, responseType: 'blob', timeout: 120000 });
export const getScheduledReports = ()        => api.get('/api/reports/scheduled').then(r => r.data);
export const createScheduledReport = (data)  => api.post('/api/reports/scheduled', data).then(r => r.data);

// ── Webhooks ──────────────────────────────────────────────────────────
export const getWebhookStatus = ()           => api.get('/api/webhooks/status').then(r => r.data);
export const testWebhook      = (dest)       => api.post('/api/webhooks/test', { destination: dest }).then(r => r.data);

// ── Ingest ────────────────────────────────────────────────────────────
export const ingestEvents     = (payload)    => api.post('/api/ingest', payload).then(r => r.data);
export const ingestVPCFlow    = (lines)      => api.post('/api/ingest/vpc-flow', { lines }).then(r => r.data);

// ── Audit ─────────────────────────────────────────────────────────────
export const getAuditLog      = (params = {}) => api.get('/api/audit-log', { params }).then(r => r.data);

export default api;
